'use client'

import classNames from 'classnames'
import { Layer } from '@dustin-web/styledust/constants'
import React, { useEffect, useState } from 'react'
import { getLayerClassName } from '../utils/get-layer-class-name'

type Props = {
  show: boolean
  local?: boolean
  whiteBackground?: boolean
  onClick?: () => void
  animationDuration?: string
  zIndex?: number
  className?: string
  layer?: Layer
}

const Overlay = ({
  show,
  local = false,
  whiteBackground = false,
  animationDuration = '',
  onClick,
  zIndex,
  className,
  layer,
}: Props) => {
  const [excludeFromDOM, setExcludeFromDOM] = useState(true)

  useEffect(() => {
    if (show) {
      setExcludeFromDOM(false)
    }
  }, [show])

  if (excludeFromDOM) {
    return null
  } else {
    return (
      <div
        className={classNames('c-overlay', className, layer ? getLayerClassName(layer) : '', {
          'a-fade-in': show,
          'a-fade-out': !show,
          'c-overlay--local': local,
          'c-overlay--white': whiteBackground,
        })}
        onAnimationEnd={() => setExcludeFromDOM(!show)}
        onClick={onClick}
        onKeyDown={event => {
          if (event.code === 'Enter' && onClick) {
            onClick()
          }
        }}
        style={{
          ...(zIndex ? { zIndex } : {}),
          ...(animationDuration ? { animationDuration } : {}),
        }}></div>
    )
  }
}

export default Overlay
